// import request from '@/util/server.js'
import {uploadURL} from '@/util/server.js'

export const upload = uploadURL + '/file/upload'



// WEBPACK FOOTER //
// ./src/api/upload.js